var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpeakActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5569 6.42981C15.5569 4.46546 13.9645 2.87305 12.0001 2.87305C10.0358 2.87305 8.44336 4.46546 8.44336 6.42981V12.1206C8.44336 14.085 10.0358 15.6774 12.0001 15.6774C13.9645 15.6774 15.5569 14.085 15.5569 12.1206V6.42981Z",
    fill: "url(#paint0_linear_7047_80114)",
    stroke: "url(#paint1_linear_7047_80114)",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.5233V22.08",
    stroke: "url(#paint2_linear_7047_80114)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.402 12.1211C18.402 13.8191 17.7275 15.4475 16.5269 16.6481C15.3262 17.8488 13.6978 18.5233 11.9998 18.5233C10.3019 18.5233 8.67345 17.8488 7.47281 16.6481C6.27217 15.4475 5.59766 13.8191 5.59766 12.1211",
    stroke: "url(#paint3_linear_7047_80114)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7047_80114",
    x1: 12.9083,
    y1: 2.63145,
    x2: 12.2824,
    y2: 16.0255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1851B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99AFD3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7047_80114",
    x1: 12.9083,
    y1: 2.87305,
    x2: 12.9083,
    y2: 15.6759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E3C81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95ACD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7047_80114",
    x1: 12.6277,
    y1: 18.5233,
    x2: 12.6277,
    y2: 22.0796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E3C81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95ACD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7047_80114",
    x1: 13.6345,
    y1: 12.1211,
    x2: 13.6345,
    y2: 18.5225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E3C81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95ACD2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakActive);
export default __webpack_public_path__ + "static/media/speakActive.69befbc999eb526cf6254b707528bc4a.svg";
export { ForwardRef as ReactComponent };